export default "__VITE_ASSET__BrFHavs4__"